import { render, staticRenderFns } from "./404.vue?vue&type=template&id=1b12b04e"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/serbanhoratiutudor/Projects/genie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b12b04e')) {
      api.createRecord('1b12b04e', component.options)
    } else {
      api.reload('1b12b04e', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=1b12b04e", function () {
      api.rerender('1b12b04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Errors/404.vue"
export default component.exports